import { QueryClient, QueryClientProvider as TQProvider } from '@tanstack/react-query';
import { FC, PropsWithChildren } from 'react';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});

export const QueryClientConfigProvider: FC<PropsWithChildren> = ({ children }) => (
  <TQProvider client={queryClient}>{children}</TQProvider>
);
